import styled from 'styled-components';
import { colors } from '../../../utils/colors';

export const BtnVerde = styled.button`
  background-color: ${colors.verde};
  border: none;
  max-width: 360px;
  min-width: 250px;
  width: 100%;
  height: 46px;
  border-radius: 22px;
  color: ${colors.branco};
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background-color: ${colors.branco} !important;
    color: ${colors.verde} !important;
    border: 1px solid ${colors.verde} !important;
  }
`;
